var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompletedOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C11.1613 0 12.0228 0.948356 12.6426 2.11111H16C17.1046 2.11111 18 3.05629 18 4.22222V16.8889C18 18.0548 17.1046 19 16 19H4C2.89543 19 2 18.0548 2 16.8889V4.22222C2 3.05629 2.89543 2.11111 4 2.11111H7.35735C7.97718 0.948356 8.83869 0 10 0ZM6.10973 5.75942C6.19136 5.37391 6.32101 4.82708 6.50686 4.22222H4V16.8889H16V4.22222H13.4931C13.679 4.82708 13.8086 5.37391 13.8903 5.75942C13.9539 6.05996 13.7222 6.33333 13.415 6.33333H6.58504C6.27783 6.33333 6.04609 6.05996 6.10973 5.75942ZM10 4.22222C10.5523 4.22222 11 3.74963 11 3.16667C11 2.5837 10.5523 2.11111 10 2.11111C9.44772 2.11111 9 2.5837 9 3.16667C9 3.74963 9.44772 4.22222 10 4.22222Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6273 7.92037C13.2075 7.56152 12.5947 7.62585 12.2585 8.06404L9.09124 12.1926L7.51991 10.8494C7.10009 10.4906 6.48724 10.5549 6.15108 10.9931L6.1098 11.0469C5.77363 11.4851 5.84145 12.1312 6.26127 12.4901L8.6267 14.512C8.803 14.6627 9.01334 14.7388 9.22294 14.7439C9.51247 14.7509 9.80058 14.6225 9.99559 14.3683L13.8128 9.3926C14.149 8.95441 14.0811 8.30828 13.6613 7.94943L13.6273 7.92037Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedOrder);
export default __webpack_public_path__ + "static/media/completed-order.0b19223e1ebb7b57254c55dc843396e1.svg";
export { ForwardRef as ReactComponent };